import axios from "axios";

const createAxiosInstance = (store) => {
  /* 
    For now we are using this approach, we will modify it in the future
    after check what we are getting on server down.
    pendingRequests used to check if there is any pending request.
    errorOccurred if there is any error occure.  
  */
  let pendingRequests = 0;
  let errorOccurred = false;

  axios.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      const { response, config } = error;
      const status = response ? response.status : undefined;
      if (
        axios.isCancel(error) ||
        error.code === "ECONNABORTED" ||
        error.message === "Network Error" ||
        (status && status >= 500)
      ) {
        pendingRequests++;
        errorOccurred = true;
        store.dispatch("settings/setNotificationVisibility", {
          status: true,
          title: "text_oops",
          message: "popup_server_error",
          closeButton: false,
        });
        if (config && config.url) {
          setTimeout(() => {
            retryRequest(config);
          }, 30000);
        }
      } else {
        console.error("Error occurred:", error.message);
      }
      return Promise.reject(error);
    }
  );

  const handleResponse = (response) => {
    pendingRequests--;
    if (pendingRequests === 0 && !errorOccurred) {
      store.dispatch("settings/setNotificationVisibility", {
        status: false,
        title: null,
        message: null,
        closeButton: true,
      });
      errorOccurred = false;
    }
    return response;
  };

  const handleError = (error) => {
    const { response, config } = error;
    const status = response ? response.status : undefined;
    if (
      (status && status >= 500) ||
      error.message === "Network Error" ||
      !error.response
    ) {
      pendingRequests++;
      errorOccurred = true;
      store.dispatch("settings/setNotificationVisibility", {
        status: true,
        title: "text_oops",
        message: "popup_server_error",
        closeButton: false,
      });
      if (config && config.url) {
        setTimeout(() => {
          retryRequest(config)
            .catch((error) => {
              console.error("Error occurred during retry:", error.message);
            });
        }, 30000);
      }
    }
    return Promise.reject(error);
  };

  const retryRequest = (config) => {
    const { method, url, data } = config;
    if (method && url) {
      return axios.request({
        method,
        url,
        data,
      });
    } else {
      return Promise.reject(new Error("Invalid request configuration"));
    }
  }

  axios.interceptors.response.use(handleResponse, handleError);

  return axios;
};

export default createAxiosInstance;